import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { getAppInsightsSettings } from './config/appInsights.config';

let reactPlugin = new ReactPlugin();

export function setUpAppInsights() {
  var appInsights = new ApplicationInsights({
      config: {
          connectionString: getAppInsightsSettings().appInsightsConnectionString,
          extensions: [reactPlugin],
          enableAutoRouteTracking: true
      }
  });
  
  appInsights.loadAppInsights();
  return appInsights;
}

export { reactPlugin };
